import { Inject } from "typescript-ioc";
import { UiComponent } from "Ui/Scripts/UiComponent";
import { UiComponentFactory } from "Ui/Scripts/UiComponentFactory";
import { EventBinder } from "Events/Scripts/EventBinder";
import { LoggerFactory } from "Logging/Scripts/LoggerFactory";
import { EndConsumerSelectorRowComponentView } from "./EndConsumerSelectorRowComponentView";
import { autobind } from "core-decorators";

export class EndConsumerSelectorRowComponent extends UiComponent {
    public get key(): string {
        return "EndConsumerSelectorRowComponent";
    }

    private _view: EndConsumerSelectorRowComponentView;
    private _onSelectCallback: (customerId: number, addressId: number) => void;
    private _onEditClickCallback: (customerId: number) => void;
    private _onDeleteClickCallback: (customerId: number) => void;

    constructor(
        @Inject componentFactory: UiComponentFactory,
        @Inject binder: EventBinder,
        @Inject loggerFactory: LoggerFactory
    ) {
        super(componentFactory, binder, loggerFactory);
    }

    public getCustomerId(): number {
        return this._view.customerId;
    }

    public getAddressId(): number {
        return this._view.addressId;
    }

    public isChecked(): boolean {
        return this._view.radioButton.getChecked();
    }

    public getCustomerName(): string {
        return this._view.customerName;
    }

    @autobind
    public onSelect(callback: (customerId: number, addressId: number) => void): void {
        this._onSelectCallback = callback;
    }

    @autobind
    public onEditClick(callback: (customerId: number) => void): void {
        this._onEditClickCallback = callback;
    }

    @autobind
    public onDeleteClick(callback: (customerId: number) => void): void {
        this._onDeleteClickCallback = callback;
    }

    @autobind
    public change(): void {
        if (this._view.editButton) {
            this._view.editButton.toggleClass(
                this.CLASS_HIDDEN,
                !this._view.radioButton.getChecked()
            );
        }
        if (this._view.deleteButton) {
            this._view.deleteButton.toggleClass(
                this.CLASS_HIDDEN,
                !this._view.radioButton.getChecked()
            );
        }
    }

    protected init(): void {
        this._view = this.createView(EndConsumerSelectorRowComponentView);
        this.bindEvents();
        this.change();
    }

    private bindEvents(): void {
        if (this._view.radioButton) {
            this._view.radioButton.bindChange(
                () => this._onSelectCallback(this.getCustomerId(), this.getAddressId()),
                this.key
            );
        }
        if (this._view.editButton) {
            this._view.editButton.bindClick(
                () => this._onEditClickCallback(this.getCustomerId()),
                this.key
            );
        }
        if (this._view.deleteButton) {
            this._view.deleteButton.bindClick(
                () => this._onDeleteClickCallback(this.getCustomerId()),
                this.key
            );
        }
    }
}
